export const noActive = (buttonMap, view) => {
    return Object.values(buttonMap)
        .filter((item) => item.enable(view))
        .every(({ $ }) => $.classList.contains('hide'));
};
//# sourceMappingURL=no-active.js.map